import { loadFavorites } from 'App/sources/FavoritePages';

import { useQuery } from '@gogame/query';

import { favorites } from './queryKeyFactory';

export const useLoadFavorites = (options) => {
  return useQuery(
    favorites(),
    (_, { signal }) => loadFavorites({}, { signal }),
    options
  );
};
